"use client";

import { useGetInquiry } from "@/hooks";
import { syncServiceSeoCache } from "@/lib";
import type { ServiceSeoData } from "@/lib";
import { IRawInquiryItem } from "@/interfaces";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

const ServiceSeoCacheSynchronizer = ({
  serviceFlag,
  seoData,
}: {
  serviceFlag?: IRawInquiryItem["flag"];
  seoData?: ServiceSeoData;
}) => {
  const router = useRouter();
  const serviceQuery = useGetInquiry({ inquiry: serviceFlag ?? "" });
  const currentServiceData = serviceQuery.data?.data ?? null;

  useEffect(() => {
    syncServiceSeoCache(currentServiceData, {
      fallbackSeoData: seoData,
      onRevalidated: router.refresh,
    });
  }, [currentServiceData, router, seoData]);

  return null;
};

export default ServiceSeoCacheSynchronizer;
